function app(state = [], action) {
    switch(action.type) {

      case 'CHANGE_LOGIN_STATUS' :
        return Object.assign({}, state,  {'login_status' : action.payload} )

      case 'ADD_LOADING' :
        return Object.assign({}, state,  {'loading' : state.loading + 1} )
      
      case 'REMOVE_LOADING' :
        let newLoading = 0;
        if(state.loading > 0){
          newLoading = state.loading - 1
        }
        return Object.assign({}, state,  {'loading' : newLoading} )

      case 'ADD_PHONE_NUMBER' :
        return Object.assign({}, state,  {'phone_number' : action.payload} )

      case 'SET_WORKSPACE' :
        return Object.assign({}, state,  {'work_space' : action.payload} )

      case 'SET_WORKSPACE_LIST' :
        return Object.assign({}, state,  {'work_space_list' : action.payload} )

      case 'START_MAIN_APP_LOADING' :
        return Object.assign({}, state,  {'main_loading' : true} )

      case 'STOP_MAIN_APP_LOADING' :
        return Object.assign({}, state,  {'main_loading' : false} )

      case 'CHANGE_SOCKET_STATUS' :
        return Object.assign({}, state,  {'socket_connect' : action.payload} )
      
      case 'UPDATE_DATETIME' :
        return Object.assign({}, state,  {'start_date' : action.payload.startDate, 'end_date': action.payload.endDate} )

      default:
        return state;
    }
  }
  
export default app;